'use client';

import { createClient } from '@/utils/supabase/client';

const supabase = createClient();
export default supabase;
